<template lang="pug">
.p-header
  transition(name="nav")
    nav.p-header-nav(v-show="active")
      ul.p-header-nav__list
        li(v-for="nav in navs")
          a(:href="nav.url" @click.prevent="clickLink(nav.url)") {{nav.text}}
  button(type="button", @click="toggle").p-header__btn
    img(v-if="active === true" :src="'/hy2022/assets/static/icon_close.svg'", alt="")
    img(v-if="active === false" :src="'/hy2022/assets/static/icon_menu.svg'", alt="")
</template>
<script>
export default {
  data() {
    return {
      active: false,
      scrollY: 0,
      navs: [
        {
          text: 'ページトップ',
          url: '#app',
        },
        {
          text: '開催概要',
          url: '#about',
        },
        {
          text: 'スケジュール',
          url: '#schedule',
        },
        {
          text: '旅行代金',
          url: '#price',
        },
        {
          text: 'フライトスケジュール',
          url: '#flight',
        },
        {
          text: '旅行条件',
          url: '#conditions',
        },
        {
          text: 'お申込みに関して',
          url: '#regarding',
        },
        {
          text: 'ご予約・お問い合わせ',
          url: '#reserve',
        },
      ]
    }
  },
  methods: {
    toggle() {
      this.active = !this.active;
      // if (window.innerWidth < 768) {
        if (this.active) {
          this.onNavigation();
        } else {
          this.offNavigation();
        }
      // }
    },
    onNavigation() {
      const body = document.body;
      this.scrollY = window.scrollY;
      body.style.top = this.scrollY * -1 + 'px';
      body.classList.add('is-scroll--lock');
    },
    offNavigation() {
      const body = document.body;
      body.classList.remove('is-scroll--lock');
      document.documentElement.scrollTop = this.scrollY;
    },
    clickLink(url) {
      if (url.indexOf('#') === 0) {
        this.active = false;
        this.offNavigation();
        const target = document.getElementById(url.replace('#', ''));
        const y = target.offsetTop;
        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else {
        location.href = url;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.nav {
  &-enter-active,
  &-leave-active {
    transition: all .5s ease;
  }
  &-enter-from,
  &-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }
}

</style>
